import { mc, StyleProps } from '@styles';
import React, { FC, MouseEventHandler, ReactNode } from 'react';

import ChevronRightIcon from './assets/chevronRight.inline.svg';
import SearchIcon from './assets/search.inline.svg';

interface Props extends StyleProps {
  children?: ReactNode;
  href?: string;
  target?: string;
  rightIcon?: 'chevronRight' | 'search';
  color?: 'blue' | 'orange';
  size?: 'xsm' | 'sm' | 'md';
  fontWeight?: 'semibold' | 'medium';
  fontSize?: 'sm' | 'md' | 'lg';
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  state?: unknown;
}

export const ContainedBtn: FC<Props> = ({
  size = 'md',
  fontWeight = 'semibold',
  style,
  className,
  href,
  children,
  rightIcon,
  color = 'blue',
  fontSize = 'md',
  ...rest
}) => {
  const sharedProps = {
    style,
    className: mc(
      `inline-block`,
      'rounded-full',
      `cursor-pointer font-${fontWeight} tracking-wide`,
      size === 'xsm' && 'px-4 py-0.5',
      size === 'sm' && 'px-4 py-2',
      size === 'md' && 'px-8 py-4',
      color === 'orange' && 'bg-salmon hover:bg-ocean-blue text-white hover:text-white',
      color === 'blue' && 'bg-ocean-blue hover:opacity-70 text-white hover:text-white',
      fontSize === 'sm' && 'text-sm',
      fontSize === 'md' && 'text-base',
      fontSize === 'lg' && 'text-lg',
      'text-center',
      className,
    ),
    role: href ? 'link' : 'button',
    ...rest,
  };

  const renderChildren = () => (
    <>
      <span className="inline-block">{children}</span>
      {rightIcon === 'chevronRight' && <ChevronRightIcon className="ml-2 inline-block" />}
      {rightIcon === 'search' && <SearchIcon width={14} className="ml-2 inline-block" />}
    </>
  );

  return (
    <a href={href} {...sharedProps}>
      {renderChildren()}
    </a>
  );
};

export type ContainedBtnProps = Props;
export default ContainedBtn;
